import pImg1 from '../images/project/img-1.jpg'
import pImg2 from '../images/project/img-2.jpg'
import pImg3 from '../images/project/img-3.jpg'
import pImg4 from '../images/project/img-4.jpg'
import pImg5 from '../images/project/img-5.jpg'
import pImg6 from '../images/project/img-5.jpg'
import pImg7 from '../images/project/img-6.jpg'
import pImg8 from '../images/project/img-7.jpg'
import pImg9 from '../images/project/img-8.jpg'
import pImg10 from '../images/project/img-9.jpg'
import pImg11 from '../images/project/img-10.jpg'
import pImg12 from '../images/project/img-11.jpg'



const Projects = [
    {
        Id: '1',
        pImg:pImg1,
        psImg:pImg12,
        title: 'Creative',
        slug: 'Creative',
        sub:'2022 - UX',
        description:'We are helping client to create WordPress websites.',
    },
    {
        Id: '2',
        pImg:pImg2,
        psImg:pImg6,
        title: 'Business',
        slug: 'Business',
        sub:'2022 - creative',
        description:'We are helping client to create WordPress websites.',
    },
    {
        Id: '3',
        pImg:pImg3,
        psImg:pImg7,
        title: 'Design',
        slug: 'Design',
        sub:'2023 - business',
        description:'We are helping client to create WordPress websites.',
    },
    {
        Id: '4',
        pImg:pImg4,
        psImg:pImg8,
        title: 'Ui Design',
        slug: 'Ui-Design',
        sub:'2020 - UI',
        description:'We are helping client to create WordPress websites.',
    },
    {
        Id: '5',
        pImg:pImg2,
        psImg:pImg11,
        title: 'Business',
        slug: 'Business',
        sub:'2020 - UI',
        description:'We are helping client to create WordPress websites.',
    },
    {
        Id: '6',
        pImg:pImg5,
        psImg:pImg6,
        title: 'Creative',
        slug: 'Creative',
        sub:'2022 - UX',
        description:'We are helping client to create WordPress websites.',
        filterName: 'landing Marketing',
    },
    {
        Id: '7',
        pImg:pImg6,
        psImg:pImg6,
        title: 'Business',
        slug: 'Business',
        sub:'2022 - creative',
        description:'We are helping client to create WordPress websites.',
        filterName: 'BranDing web',
    },
    {
        Id: '8',
        pImg:pImg7,
        psImg:pImg7,
        title: 'Design',
        slug: 'Design',
        sub:'2023 - business',
        description:'We are helping client to create WordPress websites.',
        filterName: 'landing',
    },
    {
        Id: '9',
        pImg:pImg8,
        psImg:pImg8,
        title: 'Ui Design',
        slug: 'Ui-Design',
        sub:'2020 - UI',
        description:'We are helping client to create WordPress websites.',
        filterName: 'BranDing web',
    },
    {
        Id: '10',
        pImg:pImg9,
        psImg:pImg12,
        title: 'Creative',
        slug: 'Creative',
        sub:'2022 - UX',
        description:'We are helping client to create WordPress websites.',
    },
    {
        Id: '11',
        pImg:pImg10,
        psImg:pImg6,
        title: 'Web UI/UX Design',
        slug: 'Web-UI-UX-Design',
        sub:'2023 - business',
        description:'Proin efficitur, mauris vel condimentum pulvinar, velit orci consectetur ligula, eget egestas magna mi ut arcu. Phasellus nec odio orci. Nunc id massa ante. Suspendisse sit amet neque euismod, convallis quam eget, dignissim massa.',
    },
    {
        Id: '12',
        pImg:pImg11,
        psImg:pImg7,
        title: 'Mobile UI/UX Design',
        slug: 'Mobile-UI-UX-Design',
        sub:'2020 - UI',
        description:'Proin efficitur, mauris vel condimentum pulvinar, velit orci consectetur ligula, eget egestas magna mi ut arcu. Phasellus nec odio orci. Nunc id massa ante. Suspendisse sit amet neque euismod, convallis quam eget, dignissim massa.',
    },
    {
        Id: '13',
        pImg:pImg12,
        psImg:pImg8,
        title: 'Creative Design',
        slug: 'Creative-Design',
        sub:'2022 - UX',
        description:'Proin efficitur, mauris vel condimentum pulvinar, velit orci consectetur ligula, eget egestas magna mi ut arcu. Phasellus nec odio orci. Nunc id massa ante. Suspendisse sit amet neque euismod, convallis quam eget, dignissim massa.',
    },
]    

export default Projects;